// ----------------------------------------------------------------
// <copyright company="Microsoft Corporation">
//     Copyright (c) Microsoft Corporation. All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import * as React from 'react';

import { useTranslation } from 'react-i18next';
import { logPageAction } from 'src/lib/ApplicationInsights';
import { IClaimOrder } from './../../businessLogic/sagas/serviceRequest';
import { useSelector } from 'react-redux';
import { saveLoadFactory, SaveLocation } from 'application-storage';
import { selectedCountryInfoSelector } from './../../store/countries';
import { userInfoSelector } from './../../store/user';
import { OrderType } from './../../constants/orderType';


export default function PackageInstructionsButton(props: any) {
    const { data } = props;
    const safetyLink = data && data.safetyIssueInfo;
    const { t } = useTranslation();
    const orderHistory: IClaimOrder[] = useSelector((state: any) => state.device.claims);
    const { countryName } = useSelector(state =>
        selectedCountryInfoSelector(state)
    );
    const userInfo = useSelector(state => userInfoSelector(state));

    const createdDate = orderHistory ? orderHistory[0].createdDate : {};
    const claimOrderId = orderHistory ? orderHistory[0].claimOrderId : {};
    const orderType = getOrderType(orderHistory[0]);
    const src = `${location.origin}/packageInstructions`;
    const productSafetyStorage = saveLoadFactory('productSafetyForm', SaveLocation.LocalStorage);

    function onClick() {
        logPageAction('View or Print packaging instructions link clicked');
    }

    function onClickSafetyLink(e: React.MouseEvent) {
        logPageAction('Safety Form link clicked');

        productSafetyStorage.setValue({ ...data, countryName, createdDate, claimOrderId, userInfo });
        e.stopPropagation();
    }

    function getOrderType(e: any) {
        let orderType = '';
        if (e.lineItems[0]) {
            const { notification, priority } = e.lineItems[0].progress;
            orderType = `${notification}${priority}`;
        }
        return orderType;
    }

    return (
        <div style={{ display: 'flex' }}>
            {OrderType[orderType] === OrderType.Z4F ?
                <div />
                :
                <div>
                    <a onClick={onClick} href={src} target="_blank">
                        {t('view_or_print_packaging_instructions')}
                    </a>&nbsp;&nbsp;
                    {
                        safetyLink && (<div onClick={onClickSafetyLink}>
                            <a href={`${location.origin}/productSafetyForm`} target="_blank">
                                {t('product_safety_form')}
                            </a>
                        </div>)
                    }
                </div>}
        </div>
    );
}